"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionService = void 0;
const config_1 = require("../config/config");
const api_1 = require("./api");
const auth_api_1 = require("./auth-api");
const RELAY_PATH = '/relay/api';
const STATUS_PATH = '/api/gateway/status';
const STATUS_CHECK_PATH = '/api/gateway/status/check';
class SessionService {
    static async status() {
        await SessionService.statusGet();
        await SessionService.statusPost();
    }
    static async isStatusActive(throwOnError = true) {
        try {
            const [getStatus, postStatus] = await Promise.all([
                SessionService.statusGet(true),
                SessionService.statusPost(true)
            ]);
            return (getStatus === null || getStatus === void 0 ? void 0 : getStatus.status) && (postStatus === null || postStatus === void 0 ? void 0 : postStatus.status);
        }
        catch (error) {
            if (throwOnError)
                throw error;
            return false;
        }
    }
    static async statusPost(useStatusCheck = false) {
        try {
            const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
            const url = useStatusCheck ? STATUS_CHECK_PATH : STATUS_PATH;
            return await api.post({
                url,
                body: {}
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async statusGet(useStatusCheck = false) {
        try {
            const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
            const url = useStatusCheck ? STATUS_CHECK_PATH : STATUS_PATH;
            return await api.get({
                url
            });
        }
        catch (e) {
            throw e;
        }
    }
    static async init() {
        try {
            const api = config_1.react_core_config.internalConfig.gatewayV2 ? auth_api_1.AUTHAPI : api_1.API;
            return await api.post({
                url: `${RELAY_PATH}/init`,
                body: {}
            });
        }
        catch (e) {
            throw e;
        }
    }
}
exports.SessionService = SessionService;
//# sourceMappingURL=session-service.js.map